import React from 'react';

import Image from '../../../../library/image/image';
import Link from '../../../../library/link/link';
import Typography from '../../../../library/typography/typography';

import { ServiceFlagData } from '../../../../shared/types/graphql-types';

import './additional-store-services.scss';

interface AdditionalStoreServicesProps {
  servicesList: Array<ServiceFlagData>;
}

function AdditionalStoreServices(props: AdditionalStoreServicesProps) {
  const { servicesList } = props;

  return (
    <div styleName="container">
      <Typography styleName="header">Additional Services:</Typography>
      <div styleName="services">
        {servicesList?.map(service => {
          const { code, iconUrl, link, name } = service;

          return (
            <div
              data-testid="additional-service"
              key={code}
              styleName="service"
            >
              {iconUrl && <Image alt={`${name} Icon`} src={iconUrl} />}
              {link ? (
                <Link to={link}>{name}</Link>
              ) : (
                <Typography
                  size="small"
                  styleName="service-text"
                  tag="span"
                  weight="black"
                >
                  {name}
                </Typography>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default AdditionalStoreServices;
